export default "assets/images/icons/icon-marker-bcd5caff.svg";